export const tasteElementsOrder = [
  'acidity',
  'sweetness',
  'intensity',
  'complexity',
  'tannin'
]
